import type { ApiScopeRequirement } from '@ipfabric/utils';

export const createTableApiScopeRequirement = (
  apiEndpoint: string,
): ApiScopeRequirement => ({
  method: 'POST',
  path: apiEndpoint,
});
